/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ClearIcon from "@mui/icons-material/Clear";
import { ZoomIn, ZoomOut, RestartAlt, VisibilityOff, Visibility } from "@mui/icons-material";

import {
  CardContent,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Divider as MuiDivider,
  Paper as MuiPaper,
  TextField,
  Typography,
  Box,
  Avatar,
  Modal,
  Button,
  Snackbar,
  Alert,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { spacing } from "@mui/system";
import axios from "../../CustomAxios";
import Loading from "../components/Loading";
import DocumentUpload from "../components/DocumentUpload";

const Card = styled(MuiCard)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

const Mob = styled.div`
  ${(props) => props.theme.breakpoints.down("md")} {
    display: none;
  }
`;

const getCompanyProfile = async (company, setState, setErr) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + authData.access_token,
      },
    };
    const { data } = await axios.get(
      `/api/v1/${authData?.type}/ap_company/${company}`,
      config
    );
    if (data.success) {
      setState((prev) => {
        return { ...prev, profile: data.data };
      });
      setLinks(data.data.documents, setState);
    }
  } catch (e) {
    setErr(e.response.data.error);
    setState((prev) => {
      return { ...prev, loader: false };
    });
  }
};

const setLinks = (document, setState) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    let urls = [];
    document.map((doc) => {
      const type = doc?.document_storage_info?.key?.split(".")[1];
      urls.push({
        url: `/api/v1/${authData?.type}/media/${doc.document_storage_info.key}`,
        name: doc.document_title,
        type: type,
        key: doc?.document_storage_info?.key,
      });
    });
    sendRequests(urls, setState);
  } catch (e) {
    console.log(e);
  }
};

const sendRequests = async (urls, setState) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    let num = urls.length;
    if (num === 0) {
      setState((prev) => {
        return { ...prev, loader: false };
      });
    }
    const allUrls = [];
    let n = 0;
    let promiseArr = urls.map((l) => {
      let PROD_URL = "";
      if (process.env.NODE_ENV === "development") {
        PROD_URL = process.env.REACT_APP_BACKEND_DEV_API_URL;
      } else {
        PROD_URL = process.env.REACT_APP_BACKEND_PRODUCTION_API_URL;
      }

      fetch(PROD_URL + l.url, {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
        method: "GET",
      })
        .then(async (resp) => {
          return resp.arrayBuffer();
        })
        .then(async (res) => {
          n++;
          if (l.type === "pdf") {
            const myFile = new Blob([res], { type: "application/pdf" });
            const url = URL.createObjectURL(myFile);

            allUrls.push({ url: url, name: l.name, type: l.type, key: l.key });
          } else {
            const myFile = new Blob([res], { type: "image/png" });
            const url = URL.createObjectURL(myFile);
            allUrls.push({ url: url, name: l.name, type: l.type, key: l.key });
          }
          if (n === num) {
            setState((prev) => {
              return { ...prev, urls: allUrls };
            });
            setState((prev) => {
              return { ...prev, loader: false };
            });
          }
        });
    });

    // setLoader(false);
  } catch (e) {
    console.log(e);
  }
};

const BigAvatar = styled(Avatar)`
  width: 92px;
  height: 92px;
  text-align: center;
  margin: 0 auto ${(props) => props.theme.spacing(5)};
`;

function DefaultTextFields({ loader, profile, urls, id, state, setState }) {
  const [del, setDelete] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [u, setU] = useState();
  const [type, setType] = useState();
  const handleOpen = (url, type) => {
    // if(type!=="pdf"){

    setU(url);
    setType(type);
    setOpen(true);
    setModalImgHeight(70);
    // }else{
    // window.open(url)
    // }
  };
  const handleClose = () => setOpen(false);
  const snackRef = useRef(null);
  const [st, setSt] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, op } = st;
  const handleClick = (newState) => () => {
    setSt({ op: true, ...newState });
  };
  const handleCloseSnack = () => {
    setSt({ ...st, op: false });
  };
  const [err, setErr] = useState("");
  const [success, setSuccess] = useState(false);
  // const [loader, setLoader] = useState(false);
  const formData = new FormData();
  const [message, setMessage] = useState("");
  const [openAddDoc, setOpenAdddoc] = useState(false);
  const [modalImgHeight, setModalImgHeight] = useState(70);
  const handleDownDoc = () => {
    setOpenAdddoc(false);
    setImages({});
    setDocuments({});
  };
  const handleOpenDoc = () => {
    setOpenAdddoc(true);
  };
  const [documents, setDocuments] = useState({});
  const [images, setImages] = useState({});
  const [showPassword, setShowPassword] = useState(false)

  const deleteDocument = async (key) => {
    try {
      setState({ ...state, loader: true });
      const authData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };
      const { data } = await axios.delete(
        `/api/v1/${authData?.type}/media/ap_company/${id}/${key}`,
        config
      );
      if (data.success) {
        setSuccess(true);
        setErr("");
        setMessage("Document Deleted successfully");
        snackRef.current.click();
        window.location.reload();
      }
    } catch (e) {
      setErr(e.response.data.error);
      snackRef.current.click();
      setState({ ...state, loader: false });
      console.log(e);
    }
  };

  const addDocuments = async () => {
    try {
      let br = 0;
      Object.values(images).map((doc, i) => {
        if (!documents[i]) {
          setErr("Document Name field cannot be empty");
          setSuccess(false);
          snackRef.current.click();
          br = 1;
          return;
        }
      });
      if (!br) {
        setState({ ...state, loader: true });
        const authData = JSON.parse(localStorage.getItem("AuthData"));
        Object.values(images).map((image, i) => {
          formData.set(`document_${i + 1}_file`, image);
        });
        Object.values(documents).map((doc, i) => {
          formData.set(`document_${i + 1}_name`, doc);
          
        });
        const config = {
          headers: {
            Authorization: "Bearer " + authData.access_token,
          },
        };
        const { data } = await axios.post(
          `/api/v1/${authData?.type}/media/ap_company/${id}`,
          formData,
          config
        );
        if (data.success) {
          setSuccess(true);
          setErr("");
          setMessage("Documents Added Successfully");
          snackRef.current.click();
          window.location.reload();
        }
      }
    } catch (e) {
      setErr(e.response.data.error);
      snackRef.current.click();
      setState({ ...state, loader: false });
      console.log(e);
    }
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    // width: 400,
    bgcolor: "background.paper",
    // bgcolor: 'transparent',
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  return (
    <>
      <Button
        ref={snackRef}
        style={{ display: "none" }}
        onClick={handleClick({ vertical: "top", horizontal: "center" })}
      >
        Click
      </Button>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={op}
        onClose={handleCloseSnack}
        key={vertical + horizontal}
      >
        {err ? (
          <Alert mt={2} mb={4} severity="error">
            {err}
          </Alert>
        ) : success ? (
          <Alert mt={2} mb={4} severity="success">
            {message}
          </Alert>
        ) : null}
      </Snackbar>
      {!state.loader ? (
        <form>
          <Card mb={6}>
            <CardContent>
              <form noValidate autoComplete="off">
                <Paper elevation={3} style={{ padding: "2%" }}>
                  <Grid container spacing={5}>
                    <Grid item xs={12} lg={12} md={12}>
                      <Typography variant="h4" gutterBottom>
                        Alpha Plus Company Profile Page
                      </Typography>
                    </Grid>
                    {urls.map((url, i) => {
                      if (url.name === "profile_picture") {
                        return <BigAvatar src={url.url} />;
                      }
                    })}
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        value={profile?.name}
                        inputProps={{ readOnly: true }}
                        id="standard-required"
                        label="Name"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        value={profile?.email_address}
                        inputProps={{ readOnly: true }}
                        id="standard-required"
                        label="Email"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        value={profile?.gst_number}
                        inputProps={{ readOnly: true }}
                        id="standard-required"
                        label="GST Number"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        value={profile?.pan_number}
                        inputProps={{ readOnly: true }}
                        id="standard-required"
                        label="PAN Number"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        value={profile?.bank_details}
                        inputProps={{ readOnly: true }}
                        id="standard-required"
                        label="Bank Details"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        value={profile?.phone_number}
                        inputProps={{ readOnly: true }}
                        id="standard-required"
                        label="Phone Number"
                        fullWidth
                      />
                    </Grid>

                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        value={profile?.landline_number}
                        inputProps={{ readOnly: true }}
                        id="standard-required"
                        label="Landline Number"
                        fullWidth
                      />
                    </Grid>

                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        inputProps={{ readOnly: true }}
                        label="Address Line 1"
                        value={profile?.address_line_one}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        inputProps={{ readOnly: true }}
                        label="Address Line 2"
                        value={profile?.address_line_two}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        inputProps={{ readOnly: true }}
                        label="Pincode"
                        value={profile?.pincode}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        inputProps={{ readOnly: true }}
                        label="State"
                        value={profile?.state}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        inputProps={{ readOnly: true }}
                        label="City"
                        value={profile?.city}
                        fullWidth
                      />
                    </Grid>
                    {profile?.irn_username?(
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        fullWidth
                        inputProps={{ readOnly: true }}
                        label={"IRN Username"}
                        value={profile?.irn_username}
                      />
                    </Grid>

                      ):""}
                     {profile?.irn_password?(
                      <Grid item xs={12} lg={12} md={12}>
                        <TextField
                          fullWidth
                          value={profile?.irn_password}
                          inputProps={{ readOnly: true }}
                          type={showPassword?"text" : "password"}
                          label={"IRN Password"}
                          InputProps={{
                            endAdornment: <InputAdornment position="end">
                            <IconButton
                              onClick={()=>setShowPassword(!showPassword)}
                              edge="end"
                            >
                              {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                          }}
                        />
                      </Grid>):("")}
                  </Grid>
                </Paper>
              </form>
            </CardContent>
          </Card>

          <Modal open={open} onClose={handleClose}>
            <Card sx={style}>
              <CardContent>
                <Paper>
                  <Grid container justifyContent="center" spacing={5}>
                    <Grid
                      item
                      xs={12}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <IconButton
                        onClick={() => setModalImgHeight(modalImgHeight + 5)}
                      >
                        <ZoomIn />
                      </IconButton>
                      <IconButton
                        onClick={() => setModalImgHeight(modalImgHeight - 5)}
                      >
                        <ZoomOut />
                      </IconButton>
                      <IconButton onClick={() => setModalImgHeight(70)}>
                        <RestartAlt />
                      </IconButton>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        maxHeight: "72.5vh",
                        overflowY: "scroll",
                      }}
                    >
                      {type !== "pdf" ? (
                        <Box
                          component={"img"}
                          src={u}
                          height={modalImgHeight.toString() + "vh"}
                          width="auto"
                        />
                      ) : (
                        <iframe
                          height={(modalImgHeight + 420).toString() + "vh"}
                          width={(modalImgHeight + 420).toString() + "vh"}
                          src={u}
                        />
                      )}
                    </Grid>
                  </Grid>
                </Paper>
              </CardContent>
            </Card>
          </Modal>
          <Modal
            open={openAddDoc}
            onClose={handleDownDoc}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography
                id="modal-modal-title"
                variant="h6"
                align="center"
                color="primary"
              >
                Add Documents
              </Typography>
              <DocumentUpload
                documents={documents}
                setDocuments={setDocuments}
                images={images}
                setImages={setImages}
              />
              <Button onClick={addDocuments}>Add</Button>
            </Box>
          </Modal>
          <Card mb={6}>
            <CardContent>
              <Paper elevation={3} style={{ padding: "2%" }}>
                <Grid container spacing={5}>
                  <Grid item xs={12} lg={12} md={12}>
                    <Typography variant="h4" gutterBottom>
                      Document Details
                    </Typography>
                  </Grid>
                </Grid>
                {!profile?.documents.length ? (
                  <Grid item xs={12} md={12} lg={12}>
                    <Typography variant="h6" color="primary" gutterBottom>
                      No Documents Added
                    </Typography>
                  </Grid>
                ) : null}
                {profile.documents &&
                  profile.documents.map((document, i) => {
                    if (urls[i]?.name !== "profile_picture") {
                      return (
                        <Paper
                          style={{ display: "flex", alignItems: "center" }}
                          mt={3}
                        >
                          <Box
                            component="img"
                            width="90px"
                            height="80px"
                            onClick={() =>
                              handleOpen(urls[i]?.url, urls[i]?.type)
                            }
                            src={
                              urls[i]?.type === "pdf"
                                ? "/static/img/images/pdf.png"
                                : urls[i]?.url
                            }
                            style={{ cursor: "pointer" }}
                          />
                          <TextField
                            fullWidth
                            margin="dense"
                            m={2}
                            style={{ marginLeft: 32 }}
                            inputProps={{ readOnly: true }}
                            id="standard-required"
                            label="Document Name"
                            value={urls[i]?.name || ""}
                          />
                          {!del ? (
                            <Mob>
                              <Grid item>
                                <a
                                  href={urls[i]?.url}
                                  style={{
                                    color: "inherit",
                                    textDecoration: "inherit",
                                  }}
                                  download={`${urls[i]?.name}.${urls[i]?.type}`}
                                >
                                  <FileDownloadIcon
                                    style={{
                                      marginLeft: 32,
                                      cursor: "pointer",
                                    }}
                                  />
                                </a>
                              </Grid>
                            </Mob>
                          ) : (
                            <Grid item>
                              <ClearIcon
                                onClick={() => deleteDocument(urls[i]?.key)}
                                style={{
                                  marginLeft: 32,
                                  cursor: "pointer",
                                }}
                              />
                            </Grid>
                          )}
                        </Paper>
                      );
                    }
                  })}
              </Paper>
            </CardContent>
          </Card>
        </form>
      ) : (
        <Loading />
      )}
    </>
  );
}

function ApCompanyProfile() {
  const navigate = useNavigate();
  const [profile, setProfile] = useState({});
  const [loader, setLoader] = useState(true);
  const [urls, setUrls] = useState([]);
  const { company_id } = useParams();
  const [state, setState] = useState({ profile: {}, loader: true, urls: [] });
  useEffect(() => {
    getCompanyProfile(company_id, setState, setErr);
  }, []);

  const [err, setErr] = useState(null);
  const [success, setSuccess] = useState(null);

  const snackRef = useRef(null);
  const [snackState, setSnackState] = useState({
    op: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, op } = snackState;
  const handleClick = (newState) => () => {
    setSnackState({ op: true, ...newState });
  };
  const handleClose = () => {
    setSnackState({ ...snackState, op: false });
  };

  useEffect(() => {
    if (err) {
      snackRef.current.click();
    }
  }, [err]);

  if (!state.loader) {
    return (
      <React.Fragment>
        <Button
          ref={snackRef}
          style={{ display: "none" }}
          onClick={handleClick({ vertical: "top", horizontal: "center" })}
        >
          Click
        </Button>
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={op}
          onClose={handleClose}
          key={vertical + horizontal}
        >
          {err ? (
            <Alert mt={2} mb={4} severity="error">
              {err}
            </Alert>
          ) : success ? (
            <Alert mt={2} mb={4} severity="success">
              {success}
            </Alert>
          ) : null}
        </Snackbar>

        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              AP COMPANY PROFILE
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link component={NavLink} to="/dashboard/company/ap-companies">
                Ap Companies
              </Link>
              <Typography>Profile </Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            {state.profile && (
              <DefaultTextFields
                loader={state.loader}
                id={company_id}
                urls={state.urls}
                profile={state.profile}
                setState={setState}
                state={state}
              />
            )}
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return (
      <>
        <Button
          ref={snackRef}
          style={{ display: "none" }}
          onClick={handleClick({ vertical: "top", horizontal: "center" })}
        >
          Click
        </Button>
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={op}
          onClose={handleClose}
          key={vertical + horizontal}
        >
          {err ? (
            <Alert mt={2} mb={4} severity="error">
              {err}
            </Alert>
          ) : success ? (
            <Alert mt={2} mb={4} severity="success">
              {success}
            </Alert>
          ) : null}
        </Snackbar>
        <Loading />
      </>
    );
  }
}

export default ApCompanyProfile;
